// Hooks de dados do histórico de mudanças (fatia S3b).
import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import type { ActionsPage, RevertActionResponse } from '@impulso/shared/api/actions'
import { api } from '../../lib/api'

export function useActions(companyId: string, limit = 30) {
  return useInfiniteQuery({
    queryKey: ['actions', companyId, limit],
    queryFn: ({ pageParam }) => api.get<ActionsPage>(`/companies/${companyId}/actions?limit=${limit}${pageParam ? `&cursor=${encodeURIComponent(pageParam)}` : ''}`),
    initialPageParam: '' as string,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    enabled: !!companyId,
  })
}

export function useRevertAction(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (actionId: string) => api.post<RevertActionResponse & { error?: string | null }>(`/companies/${companyId}/actions/${actionId}/revert`),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['actions', companyId] })
      void qc.invalidateQueries({ queryKey: ['autopilot', companyId] })
    },
  })
}

/** Desfaz várias ações (ex.: as criadas ao aplicar uma sugestão). */
export async function revertMany(companyId: string, actionIds: string[]): Promise<{ ok: number; failed: string[] }> {
  let ok = 0
  const failed: string[] = []
  // desfaz na ordem inversa (aumentos antes das reduções que os liberaram)
  for (const id of [...actionIds].reverse()) {
    try {
      const r = await api.post<RevertActionResponse & { error?: string | null }>(`/companies/${companyId}/actions/${id}/revert`)
      if (r.status === 'succeeded') ok++
      else failed.push(r.error ?? 'Não foi possível desfazer.')
    } catch (err) {
      failed.push(err instanceof Error ? err.message : 'Não foi possível desfazer.')
    }
  }
  return { ok, failed }
}
